import { render, staticRenderFns } from "./WidgetSubDivLayout.vue?vue&type=template&id=40f229dd&scoped=true&"
import script from "./WidgetSubDivLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetSubDivLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSubDivLayout.vue?vue&type=style&index=0&id=40f229dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f229dd",
  null
  
)

export default component.exports